module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_vision.53cea2b9.jpg";